// extracted by mini-css-extract-plugin
module.exports = {"menuPlanDivider":"JournalDay_menuPlanDivider__3AfGm"};